import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import Layers from "slotworks/graphics/layers/layers";

export class GoldenRockSpinButtonRingComponent {

    private totalSpins: number = 0;
    private playedSpins: number = 0;

    public init(): void {
        Layers.SmartButton.onSceneEnter.add(() => {
            this.updateSpinButtonRing();
        });
    }

    public setTotalSpins(total: number): void {
        this.totalSpins = total;
    }

    public setTotalPlayed(played: number): void {
        this.playedSpins = played;

        this.updateSpinButtonRing();
    }

    public setTotalLeft(left: number): void {
        this.playedSpins = this.totalSpins - left;

        this.updateSpinButtonRing();
    }

    public reset() {
        this.setTotalSpins(0);
        this.setTotalPlayed(0);
    }

    protected updateSpinButtonRing(): void {
        const spinButtonRing: AnimatedSprite = Layers.SmartButton.getAnimatedSprite("spin_button_ring");
        if (spinButtonRing && this.totalSpins > 0) {

            spinButtonRing.visible = true;
            const percent: number = this.playedSpins / this.totalSpins;

            const targetFrame: number = Math.max(0, Math.floor((spinButtonRing.totalFrames * percent) - 1));

            if (targetFrame < spinButtonRing.totalFrames) {
                spinButtonRing.gotoAndStop(targetFrame);
            }
        }
    }
}

export default new GoldenRockSpinButtonRingComponent();
